export default "__VITE_ASSET__DKbX94Ke__"